module.exports = __webpack_public_path__ + "static/img/mariana-medvedeva-usfIE5Yc7PY-unsplash_thumb.7c4d9dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/mariana-medvedeva-usfIE5Yc7PY-unsplash_thumb.png
// module id = rhUy
// module chunks = 4